<template>
    <div>
        <nav-breadcrumb :menu="[{label: '技术合作方'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "BusinessPartnerList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '合作方名称',
                        field: 'p__partnerName'
                    },
                    {
                        label: '合作方编号',
                        field: 'p__partnerCode'
                    },
                    {
                        label: '合作方类型',
                        field: 'p__partnerType',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '负责人',
                        field: 'p__contactPerson',

                    },
                    {
                        label: '联系方式',
                        field: 'p__contactNo'
                    },
                    {
                        label: '状态',
                        field: 'p__partnerStatus',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'add',
                                            query: {
                                                partnerId: row.p__partnerId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                dealerTypeOptions:[],
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        p__partnerName:'',
                        p__partnerCode:'',
                        p__partnerType:'',
                    },
                    columns: [

                        {
                            label: '合作方名称',
                            component: 'el-input',
                            field: 'p__partnerName'
                        },
                        {
                            label: '合作方编号',
                            component: 'el-input',
                            field: 'p__partnerCode'
                        },
                        {
                            label: '合作方类型',
                            component: 'el-select',
                            field: 'p__partnerType',
                            options: [
                                {
                                    label:'助贷机构',
                                    value:'A'
                                },
                                {
                                    label:'资管公司',
                                    value:'B'
                                },
                                {
                                    label:'技术服务',
                                    value:'C'
                                }
                            ],
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBusinessPartnerList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },

            removeItem: function (index, row) {
                removeItem(
                    xhr.updateBusinessPartner,
                    {
                        'p.partnerId' : row.p__partnerId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/BusinessPartnerList.vue